<template>
  <div class="address-input-form">
    <p>住所<span v-if="kana">（カナ）</span></p>
    <p v-if="!kana">郵便番号（ハイフン無し）</p>
    <input class="text_form" v-if="!kana" type="number" v-model="postal_code" placeholder="0000000">

    <p>都区道府県<span v-if="kana">（カナ）</span></p>
    <input class="text_form" v-if="!kana" type="text" v-model="address.state" placeholder="東京都台東区 / 埼玉県">
    <input class="text_form" v-else type="text" v-model="address.state" placeholder="トウキョウトタイトウク / サイタマケン">

    <p>市町村<span v-if="kana">（カナ）</span></p>
    <input class="text_form" v-if="!kana" type="text" v-model="address.city" placeholder="上野 / さいたま市">
    <input class="text_form" v-else type="text" v-model="address.city" placeholder="ウエノ / サイタマシ">

    <p>丁目<span v-if="kana">（カナ）</span></p>
    <input class="text_form" v-if="!kana" type="text" v-model="address.town" placeholder="X丁目">
    <input class="text_form" v-else type="text" v-model="address.town" placeholder="Xチョウメ">

    <p>番地<span v-if="kana">（カナ）</span></p>
    <input class="text_form" v-if="!kana" type="text" v-model="address.line1" placeholder="Y番Z号">
    <input class="text_form" v-else type="text" v-model="address.line1" placeholder="YバンZゴウ">

    <p>建物名・部屋番号<span v-if="kana">（カナ）</span></p>
    <input class="text_form" v-if="!kana" type="text" v-model="address.line2" placeholder="PアパートQ番">
    <input class="text_form" v-else type="text" v-model="address.line2" placeholder="PアパートQバン">
  </div>
</template>

<script>
  export default {
    name: "AddressInputForm",

    props: {
      value: {
        required: true
      },
      kana: {
        type: Boolean,
        required: true,
      }
    },

    data() {
      return {
        address: {
          country: 'JP',
          state: '',
          city: '',
          town: '',
          line1: '',
          line2: '',
        },
        postal_code: '',
      }
    },

    watch: {
      address: {
        handler: function () {
          this.$emit('input', this.address)
        },
        deep: true
      },
      postal_code: {
        handler: function () {
          this.$emit('setTempPostalCode', this.postal_code)
        },
      },
    },
  }
</script>


<style lang="scss" scoped>
  .address-input-form {
    .text_form {
      width: 100%;
    }
  }
</style>